<template>
    <div class="footer">
        <div class="footer__container">
            <a :href="data.link" target="_blank" class="footer__logo">
            <img :src="require(`../assets/img/logo/white/${nav.logo}`)" :alt="nav.name">
            </a>
            <div class="footer__nav">
                <a v-for="(item, i) in data.links" :key="i" :href="item.url">{{ item.text }}</a>
            </div>
            <div class="footer__copyright">
                <p class="copyright">{{ data.copyright }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Content from '../data/content.js'
let lang = process.env.VUE_APP_LOCALITY;

export default {
    setup() {
      return {
        data: Content[lang].footer,
        nav: Content[lang].navbar,
      }
    }
}
</script>

<style>
.footer {
    background: #ff8000;
    padding: 24px 0 50px 0;
    text-align: center;
}

.footer__container {
    max-width: 1022px;
    margin: 0 auto;
    width: 90%;
}

.footer img {
    padding: 20px 0;
    max-width: 200px;
}

.footer__nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.footer a, .footer p {
    color: white;
    text-decoration: none;
    font-family: "JET Sans Digital";
    font-size: 16px;
    margin: 0 auto 35px;
}
.footer a:hover {
    text-decoration: underline;
}
.footer p {
    margin-bottom: 0;
}
@media only screen and (max-width: 992px) { 
    .footer__nav a {
        width: 100%;
        margin-bottom: 20px;
        font-size: 14px;
    }

    .footer__nav p {
        font-size: 14px;
    }
}
</style>